import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'

import {
  updateTablesAction,
  clearTables,
} from 'containers/Entity/actions'

import {
  get,
  post,
  getRequest
} from 'helpers/RequestUtil'

import {
  UPDATE_ACTIVE_DIALOG
} from 'containers/Admin/PartnerSite/PartnerSite/constants'

import {
  FETCH_SITE_ROLES,
  POST_SITE_ROLES,
} from './constants'

import {
  selectedValueSelector,
} from 'containers/Admin/PartnerSite/PartnerSiteSelection/selectors'

import {
  siteRolesSelector,
  siteRolesChanges,
} from './selectors'

import {
  updateSiteRoles,
  updateSiteRolesChange,
  fetchSiteRolesStart,
  fetchSiteRolesSuccess,
  fetchSiteRolesError,
  postSiteRolesStart,
  postSiteRolesSuccess,
  postSiteRolesError,
} from './actions'

import {
  updateAeRegionList,
  fetchAeRegionListStart,
  fetchAeRegionListSuccess,
  fetchAeRegionListError,
  updateAeRegion,
  fetchAeRegionStart,
  fetchAeRegionSuccess,
  fetchAeRegionError,
} from 'containers/Admin/PartnerSite/PartnerSiteAddDialog/actions'

import {
  aeRegionSelector,
} from 'containers/Admin/PartnerSite/PartnerSiteAddDialog/selectors'

function* fetchSiteRoles(partnerSiteId) {
  try {
    yield put(fetchSiteRolesStart())
    const data = yield call(get, `/api/fulcrum/partner/sites/${partnerSiteId}/roles`)
    const { result: { site_role_views: roles } } = data
    yield put(updateTablesAction(data))
    yield put(fetchSiteRolesSuccess())
    return roles
  } catch(error) {
    yield put(fetchSiteRolesError(error))
  }
}

function* fetchAeRegion(partnerSiteId) {
  try {
    yield put(fetchAeRegionStart())
    const { data } = yield call(getRequest, `/api/fulcrum/partner/sites/${partnerSiteId}/ae_region`)
    yield put(fetchAeRegionSuccess())
    return data.attributes.aeRegion
  } catch(error) {
    yield put(fetchAeRegionError(error))
  }
}

function* fetchAeRegionList() {
  try {
    yield put(fetchAeRegionListStart())
    const data = yield call(getRequest, '/api/fulcrum/admin/ae_regions')
    yield put(fetchAeRegionListSuccess())
    return data
  } catch(error) {
    yield put(fetchAeRegionListError(error))
  }
}

function* postSiteRoles(partnerSiteId, team, aeRegion) {
  try {
    yield put(postSiteRolesStart())
    const postRequest = post('roles', { team, partnerSiteId, aeRegion })
    yield call(postRequest, `/api/fulcrum/partner/sites/${partnerSiteId}/roles`)
    yield put(postSiteRolesSuccess())
  } catch(error) {
    yield put(postSiteRolesError(error))
  }
}

function* handleFetchSiteRoles() {
  const partnerSiteId = yield select(selectedValueSelector)
  const roles = yield call(fetchSiteRoles, partnerSiteId)
  yield put(updateSiteRoles(roles))
  const team = yield select(siteRolesSelector)
  yield put(updateSiteRolesChange(team))
}

function* handleFetchAeRegion() {
  const partnerSiteId = yield select(selectedValueSelector)
  const data = yield call(fetchAeRegion, partnerSiteId)
  yield put(updateAeRegion(data))
}

function* handleFetchAeRegionList() {
  const data = yield call(fetchAeRegionList)
  yield put(updateAeRegionList(data))
}

function* handlePostSiteRoles(action) {
  const partnerSiteId = yield select(selectedValueSelector)
  const team = yield select(siteRolesChanges)
  const aeRegion = yield select(aeRegionSelector)
  yield call(postSiteRoles, partnerSiteId, team, aeRegion)
}

function * handleEditPartnerSiteRole(action) {
  const { active } = action
  if (active) {
    yield call(handleFetchSiteRoles)
    yield call(handleFetchAeRegionList)
    yield call(handleFetchAeRegion)
  }
}

function* watchEditPartnerSiteRole() {
  yield takeLatest(UPDATE_ACTIVE_DIALOG, handleEditPartnerSiteRole)
}

function* watchFetchSiteRoles() {
  yield takeEvery(FETCH_SITE_ROLES, handleFetchSiteRoles)
}

function* watchPostSiteRoles() {
  yield takeEvery(POST_SITE_ROLES, handlePostSiteRoles)
}

function* loadSagas() {
  yield all([
    fork(watchFetchSiteRoles),
    fork(watchPostSiteRoles),
    fork(watchEditPartnerSiteRole),
  ])
}

export default loadSagas
